import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./usergroup.css";
import Select from 'react-select';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { apiService } from '../../services/apiService';
import { useNavigate } from 'react-router-dom';
import { AsyncPaginate } from 'react-select-async-paginate';
function UserGroupAdd() {
    const navigate = useNavigate();
    const [inputValue, setInputValue] = useState('');
    const [errors, setErrors] = useState({});
    const [selectValue, setSelectValue] = useState('');
    const [rolesUsers, setUsersOptions] = useState([]);
    const [selectUsers, setSelectUser] = useState([]);
    const [rolesTypeUsers, setUsersTypeOptions] = useState([]);
    const [selectUsersTypes, setSelectUserTypes] = useState([]);
    const [selectManager, setSelectManager] = useState([]);
    const [errorsmessage, setErrorMessage] = useState('');
    const [submitloader, setSubmitloader] = useState(false);
    const [tabsOption, setTabsOptions] = useState([]);
    const [permissionOption, setPermssionOptions] = useState([]);
    const [selectPermission, setSelectPermission] = useState([]);
    const [selectPermissionTypes, setSelectPermissionTypes] = useState([]);
    
    const fetchTabsoption = useCallback(async () => {
        try {
            const response = await apiService.postRequest('/permission/tabList');
            if(response && response.success === true){
                const options = response && response.data
                .map(role => ({
                    value: role,
                    label: role,
                }));
                setTabsOptions(options);
            }
        } catch (error) {
            console.error('Error fetching tabs:', error);
        }
    }, []);
    useEffect(() => {
        fetchTabsoption();
    }, [fetchTabsoption]);

    const handlePermissionType = (selectedOptions) => {
        setSelectPermissionTypes(selectedOptions);
        setSelectPermission([]);
    };


    const fetchPermissionoption = useCallback(async () => {
        if (selectPermissionTypes) {
            try {
                // const navigate_option = { tabs : (selectPermissionTypes ?? []).map(type => type.value)}
                const navigate_option = { tabs: selectPermissionTypes?.value ? [selectPermissionTypes.value] : []}
                const response = await apiService.postRequest('/permissions/by-tabs', navigate_option);
                if(response && response.success === true){
                    const options = response && response.data
                    .map(role => ({
                        value: role.id,
                        label: role.display_name,
                    }));
                    setPermssionOptions(options);
                }else{
                    setPermssionOptions([]);
                }
            } catch (error) {
                console.error('Error fetching tabs:', error);
            }
        }
    }, [selectPermissionTypes]);
    useEffect(() => {
        fetchPermissionoption();
    }, [fetchPermissionoption]);

    const handlePermissionChange = (selectedOptions) => {
        setSelectPermission(selectedOptions);
    };

    
    useEffect(() => {
        if (selectUsersTypes.length > 0 && selectValue) {
        const fetchRoles = async () => {
            try {
                const group_mem = {group_type : selectValue, user_type : (selectUsersTypes ?? []).map(user => user.value)}
                const response = await apiService.postRequest('/admin/role-users-list', group_mem);
                if(response && response.success === true){
                    const options = response.data
                    .map(role => ({
                        value: role.id,
                        label: role.name,
                        type: role.user_type
                    }));
                    setUsersOptions(options);
                }
            } catch (error) {
                console.error('Error fetching roles:', error);
            }
        };
        fetchRoles();
        }
    }, [selectValue, selectUsersTypes]);


    const loadOptions = async (searchQuery, loadedOptions, { page }) => {
        const params ={
            search: searchQuery,
            page : page,
            group_type: selectValue
        }
        if (selectValue === 'external') {
            try {
            const response = await apiService.postRequest(
                `admin/roles-manager-list`, params
            );
            if(response && response.success === true){
            return {
                options: response?.data?.map(item => ({
                value: item.id,
                label: item.name,
                })),
                hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
                additional: {
                page: page + 1,
                },
            };
            }else{
                return {
                    options: [],
                    hasMore: false,
                };
            }} catch (error) {
            console.error('Error loading options:', error);
            return {
                options: [],
                hasMore: false,
            };
            }
        }
    };
    
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        setErrors((prevErrors) => ({
            ...prevErrors,
            name: '',
        }));
    };
    
    const handleSelectChange = (e) => {
        setSelectValue(e.target.value); 
        setErrors((prevErrors) => ({
            ...prevErrors,
            group_type: '',
        }));
    };

    useEffect(() => {
        if(selectValue === "internal"){
            setSelectUserTypes([]);
            setUsersTypeOptions([
                {value: "sub_admin", label: "Sub Admin"},
            ])
        }else{
            setSelectUserTypes([]);
            setUsersTypeOptions([
                {value: "sub_admin", label: "Sub Admin"},
                {value: "job_seeker", label: "Jobseeker"}
            ])
        }
        setSelectManager([]);
    },[selectValue]);
    const handleUsersTypeChange = (selectedOptions) => {
        setSelectUserTypes(selectedOptions);
        setSelectUser([]);
        setUsersOptions([]);
    };
    const handleManagerChange = (selectedOptions) => {
        setSelectManager(selectedOptions);
    };

    const handleUsersChange = (selectedOptions) => {
        setSelectUser(selectedOptions);
    };
    const validateForm = () => {
        const newErrors = {};

        if (!inputValue) newErrors.name = "Group Name is required.";
        if (!selectValue) newErrors.group_type = "Group Type is required.";
        
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
  const handleSave = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
        setErrorMessage('Please fix the errors before proceeding.');
        return;
    }
      const dataToSend = {
        name: inputValue,
        permissions: (selectPermission ?? []).map(type => type.value),
        group_type: selectValue,
        sub_admins: (selectUsers ?? []).map(user => user.value),
        group_manager_id: selectManager?.value,
      };
      setSubmitloader(true);
      try {
        
        const response = await apiService.postRequest('/admin/roles', dataToSend);

        // Handle success or failure here
        if (response.success) {
            navigate('/user/group');
        } else {
          setErrorMessage(response.message || "Failed. Please try again");
            if (response.errors) {
                setErrors(response.errors);
            }
          if(response && response.authenticate === false){
              await apiService.postRequest('/auth/logout');
              localStorage.clear();
              sessionStorage.clear();
              window.location.href = '/login';
          }
        }
      } catch (error) {
        console.error('Error making API request:', error);
      }finally {
        setSubmitloader(false); // Stop loader
    }
    
  };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container justifyContent="center" className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>User</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/user/group")}>User</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/user/group")}>Group</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Add Group</span>
                    </Grid>
                    <Grid size={{xs:12}} container className="editgrouphead my-4">
                        <h2>Add Group</h2>
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container justifyContent="center">
                    <Grid size={{md:11,xs:12}} container justifyContent="space-between">
                        <Grid size={{md:5,xs:12}} container flexDirection="column" className="input_groupname">
                            <span className='fw-bold fs-6'>Group Name<small className='red_starimpo'>*</small></span>
                            <input type='text' placeholder='Group Name' onChange={handleInputChange} value={inputValue}/>
                            {errors.name && <p style={{color:"red"}}>{errors.name}</p>}
                        </Grid>
                        <Grid size={{md:5,xs:12}} container flexDirection="column" className="input_groupname">
                            <span className='fw-bold fs-6'>Group Type<small className='red_starimpo'>*</small></span>
                            <select onChange={handleSelectChange} value={selectValue}>
                                <option value="">Select</option>
                                <option value="internal">Internal</option>  
                                <option value="external">External</option>
                                <option value="hybrid">Hybrid</option>
                            </select>
                            {errors.group_type && <p style={{color:"red"}}>{errors.group_type}</p>}
                        </Grid> 
                    </Grid>
                    <Grid size={{sm:11}} container justifyContent="flex-end" className="gap-md-5 gap-2 mt-4">
                        {errorsmessage && <p style={{ color: 'red',width:"100%" }}>{errorsmessage}</p>}
                            <button onClick={() =>{navigate("/user/group")}} className='cancel_btnbonly'>Cancel</button>
                            <button onClick={handleSave} className='save_btnbonly'>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                    </Grid>
                    <Grid size={{sm:11,xs:12}} container flexDirection="column" justifyContent="center">
                    {/* {mappedTabData.length <= 0 ?
                        <div className='d-flex justify-content-center w-100'>  
                            <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> : */}
                        <Tabs
                            defaultActiveKey="member"
                            id="justify-tab-example"
                            className=" my-4 drafttabs_tabs"
                            >
                            <Tab eventKey="member" title="Members">
                                <Grid size={{xs:12}} container className="tab_membersets mt-0" style={{background:"transparent",boxShadow:"none"}} justifyContent="center" alignContent="flex-start">
                                    <Grid size={{sm:12,xs:12}} container justifyContent="space-between">
                                        
                                        {selectValue !== "" && 
                                            <Grid size={{sm: 5, xs: 12}} container alignItems="flex-start" alignContent="flex-start">
                                                <Grid size={{ xs: 12 }} container flexDirection="column" className="mb-5">
                                                    <span>Member Type</span>
                                                    <Select
                                                        isMulti
                                                        name="roles"
                                                        value={selectUsersTypes}
                                                        onChange={handleUsersTypeChange}
                                                        options={rolesTypeUsers}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Choose..."
                                                    />
                                                    {/* {errors.roles && <p style={{ color: "red" }}>{errors.roles}</p>} */}
                                                </Grid>
                                                <Grid size={{ xs: 12 }} container flexDirection="column" className="mb-5">
                                                    <span>Group Manager</span>
                                                    {selectValue === "external" ? 
                                                    <AsyncPaginate
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        loadOptions={loadOptions}
                                                        value={selectManager}
                                                        additional={{
                                                            page: 1,
                                                        }}
                                                        debounceTimeout={300}
                                                        onChange={handleManagerChange}
                                                        isClearable
                                                        cacheUniqs={[]}
                                                        reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]}
                                                    />:
                                                    <Select
                                                        name="roles"
                                                        value={selectManager}
                                                        onChange={handleManagerChange}
                                                        options={selectUsers?.filter(item => {
                                                            const type = item.type?.toLowerCase().replace(/\s+/g, "_");
                                                            return type !== "job_seeker";
                                                            })
                                                            .map(item => ({
                                                            value: item.value,
                                                            label: item.label,
                                                            type: item.type,
                                                        })) || []}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Choose..."
                                                    />}
                                                    {errors.group_manager_id && <p style={{ color: "red" }}>{errors.group_manager_id}</p>}
                                                </Grid>
                                            </Grid>
                                        }
                                        {selectUsersTypes.length !== 0 && 
                                        <Grid size={{ sm: 5, xs: 12 }} container flexDirection="column" className="mb-5">
                                            <span>Users to be added</span>
                                            <Select
                                                isMulti
                                                name="roles"
                                                value={selectUsers}
                                                onChange={handleUsersChange}
                                                options={rolesUsers}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Choose..."
                                            />
                                            {errors.sub_admins && <p style={{ color: "red" }}>{errors.sub_admins}</p>}
                                        </Grid>
                                        }
                                    </Grid>
                                    <p>No Member to display</p>
                                </Grid>
                            </Tab>
                            <Tab eventKey="permissions" title="Permissions">
                                <Grid size={{xs:12}} container className="tab_membersets mt-0" style={{background:"transparent",boxShadow:"none"}} justifyContent="center" alignContent="flex-start">
                                    <Grid size={{xs:12}} container justifyContent="space-between">
                                        <Grid size={{ sm: 5, xs: 12 }} container flexDirection="column" className="mb-5">
                                            <span>Permission Type</span>
                                            <Select
                                                // isMulti
                                                name="roles"
                                                value={selectPermissionTypes}
                                                onChange={handlePermissionType}
                                                options={tabsOption}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Choose..."
                                            />
                                        </Grid>
                                        {selectPermissionTypes.length !== 0 && 
                                            <Grid size={{ sm: 5, xs: 12 }} container flexDirection="column" className="mb-5">
                                                <span>Permission</span>
                                                <Select
                                                    isMulti
                                                    name="roles"
                                                    value={selectPermission}
                                                    onChange={handlePermissionChange}
                                                    options={permissionOption}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    placeholder="Choose..."
                                                />
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                            </Tab>
                        </Tabs>
                        {/* } */}
                    </Grid>
                </Grid>
                <Grid size={{sm:11}} container className="mb-4">
                {errorsmessage && <p style={{ color: 'red',width:"100%" }}>{errorsmessage}</p>}
                </Grid>
                <Grid size={{sm:11}} container className="ps-md-5 gap-md-5 gap-2 mb-4"> 
                    <button onClick={() =>{navigate("/user/group")}} className='cancel_btnbonly'>Cancel</button>
                    <button onClick={handleSave} className='save_btnbonly'>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default UserGroupAdd
